import { request } from './base';
import * as models from '../../models'; 
import utils from '../../utils'; 

// =========================================================================
// 1. DESIGNER ENDPOINTS (POST = Create, GET = Fetch, PUT = Save Draft, PATCH = Publish)
// =========================================================================

export const createAiToolConfiguration = async (payload: models.CreateAiToolConfiguration) => {
    return await request({
        method: 'POST', 
        url: `/ailab/tools`,
        data: payload,
    }); 
}

export const fetchAiToolConfiguration = async (toolId: number) => {
    return await request({
        method: 'GET',
        url: `/ailab/tools/${toolId}`,
    });
}

export const updateAiToolConfiguration = async (toolId: number, payload: models.CreateAiToolConfiguration) => {
    return await request({
        method: 'PUT',
        url: `/ailab/tools/${toolId}`,
        data: payload,
    });
}

export const deleteAiTool = async (toolId: number) => {
    return await request({
        method: 'DELETE',
        url: `/ailab/tools/${toolId}`,
    });
}

export const publishAiToolVersion = async (payload: models.AIToolPublishRequest) => {
    return await request({
        method: 'PATCH',
        url: `/ailab/tools/${payload.id}/publish`,
        data: payload,
    });
}

// =========================================================================
// 2. CATALOG & RUNTIME EXECUTOR ENDPOINTS
// =========================================================================

export const fetchCatalogTools = async () => {
    return await request({
        method: 'GET',
        url: `/ailab/catalog/tools`,
    });
}

/** pageSize <= 0 returns the full history (used by CSV export). */
export const fetchToolExecutionHistory = async (toolId: number, pageNo: number = 1, pageSize: number = 20) => {
    const qStr = utils.helpers.encodeQueryString({ pageNo, pageSize });
    return await request({
        method: 'GET',
        url: `/ailab/tools/${toolId}/history?${qStr}`,
    });
}

export const getClaimLevelAiTools = async (claimId: number) => {
    return await request({
        method: 'GET',
        url: `/ailab/claims/${claimId}/tools`,
    });
}

export const executeAITool = async (claimId: number, toolId: number) => {
    return await request({
        method: 'POST',
        url: `/ailab/claims/${claimId}/tools/${toolId}/execute`,
    });
}

export const matchRuntimeBundle = async (toolId: number, files: File[]) => {
    const formData = new FormData();
    files.forEach(file => formData.append('files', file));

    return await request({
        method: 'POST',
        url: `/ailab/tools/${toolId}/runtime-bundle`,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 300000
    });
}

export const submitAIToolInput = async (claimId: number, toolId: number, input: any) => {
    return await request({
        method: 'POST',
        url: `/ailab/claims/${claimId}/tools/${toolId}/input`,
        data: input
    });
}